export const legal = {
  it: {
    privacy: {
      title: "Privacy Policy",
      subtitle: "Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (“GDPR”)",
      updated: "Ultimo aggiornamento: agosto 2026",
      sections: [
        {
          h: "1. Titolare del trattamento",
          body: "Il Titolare del trattamento dei dati personali è Villa Navagero Holiday Homes, con sede in Via Grande 2, 31048 Rovarè (TV), Italia. Email: sales@villanavagero.com · Telefono: +39 329 866 7416.",
        },
        {
          h: "2. Dati personali raccolti",
          body: "Attraverso il modulo di richiesta di prenotazione raccogliamo: nome e cognome, indirizzo email, numero di telefono (facoltativo), date del soggiorno, numero di ospiti ed eventuale messaggio libero. La navigazione del sito non richiede registrazione e non raccoglie dati di profilazione.",
        },
        {
          h: "3. Finalità e base giuridica del trattamento",
          body: "I dati forniti sono trattati per: (a) gestire la richiesta di prenotazione e le relative comunicazioni — base giuridica: esecuzione di misure precontrattuali e contrattuali (art. 6, par. 1, lett. b GDPR); (b) adempiere ad eventuali obblighi di legge in materia fiscale e contabile (art. 6, par. 1, lett. c GDPR); (c) garantire la sicurezza tecnica del sito — legittimo interesse del Titolare (art. 6, par. 1, lett. f GDPR). Il conferimento dei dati è necessario per la gestione della prenotazione: in mancanza, non potremo rispondere alla richiesta.",
        },
        {
          h: "4. Modalità di trattamento e conservazione",
          body: "I dati sono trattati con strumenti informatici, con misure tecniche e organizzative adeguate a garantirne la sicurezza e la riservatezza. Le richieste di prenotazione sono conservate per il tempo necessario alla gestione del soggiorno e, successivamente, secondo i termini di legge in materia contabile (in genere 10 anni per i documenti rilevanti). I dati non sono soggetti a processi decisionali automatizzati né a profilazione.",
        },
        {
          h: "5. Comunicazione dei dati a terzi",
          body: "Per la gestione operativa delle prenotazioni i dati possono essere comunicati a: Smoobu GmbH (channel manager per la sincronizzazione dei calendari di disponibilità), fornitori di servizi tecnici e di invio email che operano come responsabili del trattamento. I dati non sono venduti né diffusi a terzi per finalità di marketing.",
        },
        {
          h: "6. Trasferimenti al di fuori dell'UE",
          body: "Alcuni fornitori tecnici potrebbero trattare dati al di fuori dello Spazio Economico Europeo; in tal caso il trasferimento avviene nel rispetto degli artt. 44 e ss. GDPR (decisioni di adeguatezza o clausole contrattuali standard).",
        },
        {
          h: "7. Diritti dell'interessato",
          body: "Ai sensi degli artt. 15–22 GDPR hai diritto di: accedere ai tuoi dati, ottenerne la rettifica o la cancellazione, limitare o opporti al trattamento, richiedere la portabilità dei dati. Puoi esercitare i diritti scrivendo a sales@villanavagero.com; risponderemo entro 30 giorni.",
        },
        {
          h: "8. Reclamo all'Autorità di controllo",
          body: "Hai il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it) qualora ritenga che il trattamento violi il GDPR.",
        },
        {
          h: "9. Modifiche alla presente informativa",
          body: "Il Titolare può aggiornare questa informativa in qualsiasi momento; la versione vigente è quella pubblicata su questa pagina con la relativa data di aggiornamento.",
        },
      ],
    },
    cookie: {
      title: "Cookie Policy",
      subtitle: "Informativa sui cookie e strumenti analoghi ai sensi del GDPR e della normativa ePrivacy",
      updated: "Ultimo aggiornamento: agosto 2026",
      sections: [
        {
          h: "1. Cosa sono i cookie",
          body: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Strumenti analoghi (es. localStorage) consentono di conservare informazioni nel browser.",
        },
        {
          h: "2. Cookie e strumenti utilizzati da questo sito",
          body: "Questo sito utilizza esclusivamente strumenti tecnici, necessari al funzionamento: (a) memorizzazione tecnica della sessione dell'area riservata gestionale (token conservato nel browser, senza finalità di tracciamento); (b) preferenze tecniche di visualizzazione. Non utilizziamo cookie di profilazione, cookie pubblicitari né strumenti di analisi statistica di terze parti. Per questi strumenti tecnici non è richiesto il consenso dell'utente.",
        },
        {
          h: "3. Contenuti incorporati di terze parti",
          body: "Il sito incorpora contenuti esterni che possono comportare la trasmissione di dati tecnici (es. indirizzo IP) al fornitore: la mappa interattiva di OpenStreetMap (OpenStreetMap Foundation — privacy policy su osmfoundation.org) e i caratteri tipografici di Google Fonts (Google Ireland Ltd). Questi contenuti non installano cookie di profilazione.",
        },
        {
          h: "4. Gestione delle preferenze",
          body: "Puoi gestire o eliminare i cookie e i dati locali del browser in qualsiasi momento dalle impostazioni del tuo browser. La cancellazione dei dati tecnici dell'area riservata comporta la semplice necessità di effettuare nuovamente l'accesso.",
        },
        {
          h: "5. Aggiornamenti",
          body: "La presente Cookie Policy può essere aggiornata in caso di modifiche agli strumenti utilizzati dal sito; la versione vigente è quella pubblicata in questa pagina. Per qualsiasi domanda: sales@villanavagero.com.",
        },
      ],
    },
  },
  en: {
    privacy: {
      title: "Privacy Policy",
      subtitle: "Information on the processing of personal data pursuant to Regulation (EU) 2016/679 (“GDPR”)",
      updated: "Last updated: August 2026",
      sections: [
        {
          h: "1. Data Controller",
          body: "The Data Controller is Villa Navagero Holiday Homes, Via Grande 2, 31048 Rovarè (TV), Italy. Email: sales@villanavagero.com · Phone: +39 329 866 7416.",
        },
        {
          h: "2. Personal data collected",
          body: "Through the booking request form we collect: full name, email address, phone number (optional), stay dates, number of guests and any free-text message. Browsing the site requires no registration and no profiling data is collected.",
        },
        {
          h: "3. Purposes and legal basis",
          body: "Your data is processed to: (a) manage your booking request and related communications — legal basis: performance of pre-contractual and contractual measures (Art. 6(1)(b) GDPR); (b) comply with legal obligations (Art. 6(1)(c) GDPR); (c) ensure the technical security of the site — legitimate interest (Art. 6(1)(f) GDPR). Providing data is necessary to handle your booking.",
        },
        {
          h: "4. Processing methods and retention",
          body: "Data is processed with IT tools and appropriate technical and organisational measures. Booking requests are kept as long as needed to manage your stay and thereafter according to statutory accounting terms. No automated decision-making or profiling is carried out.",
        },
        {
          h: "5. Disclosure to third parties",
          body: "For operational booking management, data may be shared with: Smoobu GmbH (channel manager for availability calendar synchronisation) and technical/email service providers acting as data processors. Data is never sold or shared for marketing purposes.",
        },
        {
          h: "6. Transfers outside the EU",
          body: "Some technical providers may process data outside the EEA; any such transfer complies with Articles 44 et seq. GDPR (adequacy decisions or standard contractual clauses).",
        },
        {
          h: "7. Your rights",
          body: "Under Articles 15–22 GDPR you may request access, rectification or erasure of your data, restriction of or objection to processing, and data portability. Write to sales@villanavagero.com; we reply within 30 days.",
        },
        {
          h: "8. Complaint to the supervisory authority",
          body: "You have the right to lodge a complaint with the Italian Data Protection Authority (Garante per la protezione dei dati personali, www.garanteprivacy.it).",
        },
        {
          h: "9. Changes to this notice",
          body: "The Controller may update this notice at any time; the current version is the one published on this page.",
        },
      ],
    },
    cookie: {
      title: "Cookie Policy",
      subtitle: "Information on cookies and similar tools pursuant to the GDPR and ePrivacy rules",
      updated: "Last updated: August 2026",
      sections: [
        {
          h: "1. What cookies are",
          body: "Cookies are small text files that websites send to the user's device, where they are stored and retransmitted on subsequent visits. Similar tools (e.g. localStorage) store information in the browser.",
        },
        {
          h: "2. Tools used by this site",
          body: "This site uses only technical tools required for operation: (a) technical storage of the management area session (token kept in the browser, no tracking); (b) technical display preferences. We use no profiling cookies, advertising cookies or third-party analytics. Technical tools do not require consent.",
        },
        {
          h: "3. Embedded third-party content",
          body: "The site embeds external content that may transmit technical data (e.g. IP address) to the provider: the interactive OpenStreetMap map (OpenStreetMap Foundation — privacy policy at osmfoundation.org) and Google Fonts typography (Google Ireland Ltd). These do not install profiling cookies.",
        },
        {
          h: "4. Managing preferences",
          body: "You can manage or delete cookies and local browser data at any time from your browser settings. Deleting technical data of the management area simply requires signing in again.",
        },
        {
          h: "5. Updates",
          body: "This Cookie Policy may be updated if the tools used by the site change; the current version is the one published on this page. Questions: sales@villanavagero.com.",
        },
      ],
    },
  },
};
